// extracted by mini-css-extract-plugin
module.exports = {"jobCity":"styles-module--jobCity--2A4ko","jobTitleWrapper":"styles-module--jobTitleWrapper--2EXFl","link":"styles-module--link--2d2Am"};